<template>
    <span class="global-timer-logout-root" aria-hidden="true"></span>
</template>

<script>
import { mapMutations } from "vuex";
export default {
    name: "globalTimerLogout",
    computed: {
        isLogout() {
            return this.$store.getters.getisAutoLogout;
        },
    },
    watch: {
        isLogout(value) {
            if (value === true) {
                console.log("장기간 동작이 없어 자동 로그아웃 됩니다.");
                this.alertDanger(global.xe.$t("장기간 동작이 없어 자동 로그아웃 됩니다."));
                this.$router.push("/login");
                this.setLogoutTrigger(false);
            }
        },
    },
    methods: {
        ...mapMutations(["SET_AUTO_LOGOUT_TRIGGER"]),
        setLogoutTrigger(value) {
            this.SET_AUTO_LOGOUT_TRIGGER(value);
        },
    },
};
</script>

<style scoped>
.global-timer-logout-root {
    display: none;
}
</style>
